import {Injectable} from "@angular/core";
import {AbstractSqliteDatabase} from "./abstract-sqlite.database";

@Injectable({ providedIn: 'root' })
export class StandardProductManagerDatabase extends AbstractSqliteDatabase {

    constructor() {
        super("standard_product_manager_store", "standards_products");
    }

}